var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_59968",
    "data-name": "Group 59968",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 235.69,
    height: 155.162,
    viewBox: "0 0 235.69 155.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11886",
    "data-name": "Rectangle 11886",
    width: 235.69,
    height: 155.162,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59967",
    "data-name": "Group 59967",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34028",
    "data-name": "Path 34028",
    d: "M289.915,71.573a8.351,8.351,0,0,0-2.388-4.656l-9.042-9.043V19.353a8.1,8.1,0,0,0-8.092-8.092h-38.52l-8.9-8.9a8.1,8.1,0,0,0-11.443,0l-8.9,8.9h-38.52a8.1,8.1,0,0,0-8.092,8.092v38.52l-9.042,9.043a8.353,8.353,0,0,0-2.388,4.657,8.139,8.139,0,0,0-.082,1.237l0,74.26a8.1,8.1,0,0,0,8.092,8.092H281.908A8.1,8.1,0,0,0,290,147.07V72.81s-.024-.823-.084-1.237m-3.778,8.066c.044-.027.084-.057.127-.085v60.7c-.043-.027-.084-.057-.128-.084L236.77,109.905Zm-1.251-10.082a4.6,4.6,0,0,1,1.333,2.55,4.363,4.363,0,0,1-2.034,4.348l-5.7,3.5V63.155ZM214.174,5.007a4.362,4.362,0,0,1,6.162,0l6.255,6.255H207.92ZM164.118,15H270.393a4.362,4.362,0,0,1,4.357,4.357V82.239L233.2,107.715l-11.712-7.181a8.056,8.056,0,0,0-8.459,0l-11.713,7.181L159.76,82.239V19.353A4.362,4.362,0,0,1,164.118,15m33.623,94.909-49.367,30.266c-.044.027-.085.057-.128.084v-60.7c.043.028.084.058.128.085Zm-49.449-37.8a4.6,4.6,0,0,1,1.333-2.55l6.4-6.4V79.95l-5.7-3.5a4.362,4.362,0,0,1-2.034-4.348m133.616,79.32H152.6a4.357,4.357,0,0,1-2.277-8.072l64.653-39.638a4.338,4.338,0,0,1,4.555,0l64.653,39.638a4.357,4.357,0,0,1-2.278,8.072",
    transform: "translate(-99.536 0)",
    fill: "#194253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34029",
    "data-name": "Path 34029",
    d: "M350.338,131.366A23.342,23.342,0,1,1,327,108.024a23.342,23.342,0,0,1,23.342,23.342",
    transform: "translate(-209.151 -74.405)",
    fill: "#1ca30a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34030",
    "data-name": "Path 34030",
    d: "M341.26,169.409,330.9,159.052l3.081-3.081,7.275,7.275,16.285-16.285,3.081,3.081Z",
    transform: "translate(-227.92 -101.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34031",
    "data-name": "Path 34031",
    d: "M24.275,231.686H1.867a1.867,1.867,0,1,1,0-3.735H24.275a1.867,1.867,0,1,1,0,3.735",
    transform: "translate(0 -157.008)",
    fill: "#e0ac3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34032",
    "data-name": "Path 34032",
    d: "M50.256,154.644a1.857,1.857,0,0,1-.932-.251l-19.406-11.2a1.867,1.867,0,0,1,1.867-3.234l19.406,11.2a1.868,1.868,0,0,1-.936,3.485",
    transform: "translate(-19.964 -96.226)",
    fill: "#e0ac3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34033",
    "data-name": "Path 34033",
    d: "M30.854,295.136a1.868,1.868,0,0,1-.936-3.485l19.406-11.2a1.867,1.867,0,1,1,1.867,3.234l-19.406,11.2a1.859,1.859,0,0,1-.932.251",
    transform: "translate(-19.964 -192.994)",
    fill: "#e0ac3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34034",
    "data-name": "Path 34034",
    d: "M697.585,231.686H675.177a1.867,1.867,0,1,1,0-3.735h22.408a1.867,1.867,0,0,1,0,3.735",
    transform: "translate(-463.762 -157.008)",
    fill: "#e0ac3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34035",
    "data-name": "Path 34035",
    d: "M655.84,154.644a1.868,1.868,0,0,1-.935-3.485l19.406-11.2a1.867,1.867,0,0,1,1.867,3.234l-19.406,11.2a1.856,1.856,0,0,1-.932.251",
    transform: "translate(-450.442 -96.226)",
    fill: "#e0ac3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34036",
    "data-name": "Path 34036",
    d: "M675.241,295.135a1.857,1.857,0,0,1-.932-.251l-19.406-11.2a1.867,1.867,0,0,1,1.867-3.234l19.406,11.2a1.868,1.868,0,0,1-.936,3.485",
    transform: "translate(-450.441 -192.993)",
    fill: "#e0ac3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessEmail);
export default __webpack_public_path__ + "static/media/success-email.820a74f89f59d15f509859ccc4ae850b.svg";
export { ForwardRef as ReactComponent };